import { getJwt } from "@app/helpers";
import Axios from "axios";
import { string } from "yup";
import api, { Notifiable } from "../api";
import { trackPromise } from 'react-promise-tracker';


export interface ADistribuirComuns {
    key: string;
    numeroNivel: number;
    numeroLinha: number;
    codigoPacote: string;
    nome: string;


    orcado: number,
    contratado: number,
    executado: number,
    requisitado: number,
    compromissado: number,
    aContratar: number,
    forcast: number,
    saldo: number,
    aDistribuir: number,
    compromissadoAno: number,
    executadoAnosAnterios: number,
    verificacaoAnual: number,
    verificacaoPlurianual: number,
    contratadoAno: number,
    executadoAno: number,
    requisitadoAno: number,
}

export interface ADistribuirViewResult {
    totalCompromissado: number;
    totalVerficacaoPluriAnual: number;
    totalExecutadoAnosAnteriores: number;
    totalVerificacaoAnual: number;
    totalADistribuir: number;
    totalOrcado: number
    totalContratado: number
    totalExecutado: number
    totalRequisitado: number
    totalCompromissadoAno: number
    totalAContratar: number
    totalForecast: number
    totalSaldo: number,

    colunasExecutadoMesAno: Array<ExecutadoMesAnoADistribuir>;
    colunasADistribuir: Array<ExecutadoMesAnoADistribuir>;
    children: Array<PrimeiroNivel>;
}

export interface PrimeiroNivel extends ADistribuirComuns {
    crfAcronimoAgrupadorId: string;
    colunasExecutadoMesAno: Array<ExecutadoMesAnoADistribuir>;
    colunasADistribuir: Array<ExecutadoMesAnoADistribuir>;
    children: Array<SegundoNivel>;
}

export interface SegundoNivel extends ADistribuirComuns {
    crfContaContabilCcId: string;
    children: Array<TerceiroNivel> | undefined;
    colunasExecutadoMesAno: Array<ExecutadoMesAnoADistribuir>;
}

export interface TerceiroNivel extends ADistribuirComuns {
    tipoConsolidadoPlurianualCodigo: number;
    crfContaContabilCcId: string;
    crfConsolidadoPluriAnualId: string;
    crfTipoDistribuicaoForcastId: string;
    crfTipoDistribuicaoForcastCodigo: number;
    keyNivel1: string;
    keyNivel2: string;
    periodoInicio: Date;
    periodoFim: Date;
}

export interface ResultadoADistribuirPluriAnual extends ADistribuirComuns {
    tipoConsolidadoPlurianualCodigo: number;
    crfContaContabilCcId: string;
    keyNivel1: string;
    keyNivel2: string;
}

export interface ExecutadoMesAnoADistribuir {
    key: string;
    descricao: string;
    totalColuna: number;
    dataMesAno: Date;
}

export interface CrfTipoDistribuicaoForcast {
    nome: string;
    codigo: string;
}



export enum AlteracaoEsin204 {
    OrcadoCapex = 1,
    OrcadoRfa = 2,
    OrcadoAnual = 3,
    AContratar = 4,
    Requisitado = 5,
    FornecedorPcm = 6,
    FornecedorCt = 7,
    FornecedorPcs = 8,
    Fornecedor = 9,
    MRNCombustivel = 10,
    MRNViagens = 11,
    MRNDiversos = 12,
    MRNOverhead = 13,
}

export enum EnumCrfTipoDistribuicaoForcast {
    Manual = 1,
    Linear = 2,
    CurvaEstatistica = 3,
}

export interface MesAnoADistribuir {
    colunaId: Date;
    crfConsolidadoPluriAnualId: string;
    tipoConsolidadoPlurianualCodigo: number;
    valor: number;
}

export interface FormUpdateTipoDistribuicao {
    tipoDistribuicaoForcastId: string;
    crfConsolidadoPluriAnualId: string;
}


export interface FormDataInicialFinal {
    dataRefencia: Date;
    crfConsolidadoPluriAnualId: string;
    ehDataInicial: boolean
}

export interface FormCrfConsolidadoPluriAnualById {
    crfConsolidadoPlurianualId: string;
    primeiroNivel: string;
    segundoNivel: string;
    key: string;
    indexCc: string
}
export interface GetCrfConsolidadoPluriAnualByIdCommandResult {
    crfConsolidadoPlurianual: TerceiroNivel;
    key: string;
}


export const getADistribuirByCrfProjetoId = (crfProjetoId: string, consultaRelatorio: boolean) => {
    return api.get<ADistribuirViewResult>(`crfADistribuir/getADistribuirFiltros?crfProjetoId=${crfProjetoId}&consultaRelatorio=${consultaRelatorio}`);
}

export const adcionarMesAno = (crfProjetoId: string) => {
    const form = { CrfProjetoId: crfProjetoId }
    return api.put(`crfADistribuir/creatMesAnoADistribuir`, form, { disableNotification: 'true' });
}


export const updateADistribuirMesAno = (form: MesAnoADistribuir) => {
    return api.put(`crfADistribuir/updateADistribuirMesAno`, form);
}


export const updateADistribuirTipoDistribuicao = (form: FormUpdateTipoDistribuicao) => {
    return api.put(`crfADistribuir/updateADistribuirTipoDistribuicao`, form);
}

export const updatePeriodoDataInicialOuDateFinal = (form: FormDataInicialFinal) => {
    return api.put(`crfADistribuir/updatePeriodoDataInicialOuDateFinal`, form);
}

export const updateDistribuicaoAutomaticaPorCrfProjetoId = (crfProjetoId: string) => {
    const form = { 'crfProjetoId': crfProjetoId }
    return api.put(`crfADistribuir/updateDistribuicaoAutomaticaPorCrfProjetoId`, form);
}

export const getFileADistribuirByCrfProjetoId = (crfProjetoId: string, nomeProjeto: string) => {
    let urlBase = window.location.origin;
    var today = new Date();
    const dateFormat = today.toLocaleDateString("en-US")

    trackPromise(
        Axios.get(
            urlBase +
            `/api/crfADistribuir/getFileADistribuirByCrfProjetoId/${crfProjetoId}`,
            {
                responseType: 'blob',
                headers: {
                    Authorization: `Bearer ${getJwt()}`,
                },
            },
        ).then(resp => {

            const url = window.URL.createObjectURL(new Blob([resp.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', `aDistribuir_${nomeProjeto}_${dateFormat}.xlsx`);
            link.setAttribute('id', 'downloadElementADistribuir');
            document.body.appendChild(link);
            link.click();
            document.getElementById('downloadElementADistribuir').outerHTML = '';
        }),
    );
}

export const atualizarLinhaCrfConsolidadoPluriAnual = (form: FormCrfConsolidadoPluriAnualById) => {
    return api.put<GetCrfConsolidadoPluriAnualByIdCommandResult>(`crfADistribuir/atualizarLinhaCrfConsolidadoPluriAnual`, form, { disableNotification: 'true' });
}
